import React from 'react';

/**
 * Medical Disclaimer Component
 * Displays important health advisory information
 */
const MedicalDisclaimer = () => {
  return (
    <div className="mt-8 mb-4 p-4 bg-amber-50 border border-amber-200 rounded-lg">
      <div className="flex items-start gap-3">
        <span className="text-2xl flex-shrink-0">⚠️</span>
        <div className="flex-1">
          <p className="text-sm text-amber-900 leading-relaxed">
            <strong>Avertissement :</strong> Les valeurs d'Indice et de Charge Glycémiques sont fournies à titre purement indicatif et peuvent varier selon la préparation.
            Cette application est un outil d'accompagnement personnel et ne remplace en aucun cas l'avis ou le suivi d'un professionnel de santé.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MedicalDisclaimer;
